export default __webpack_public_path__ + "assets/images/c_dashboard.32262be.jpg";